// API
import { tmxApiCall } from './index'

export default {
  async update (isMarried, spousesName, spousesAddress, applicationId) {
    return tmxApiCall('post', '/marital', {
      isMarried,
      spousesName,
      spousesAddress,
      applicationId
    })
  }
}
